import { Validators } from '@angular/forms';

export const passwordValidator = Validators.pattern(
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{8,}$/
);
